import { LoginLayout } from "layouts";
import { TextInput } from "components/TextInput";

import { useLoginPage } from "./hooks";

export const LoginPage = () => {
  const { loginState, onInputChange, signIn } = useLoginPage();

  return (
    <LoginLayout>
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-12 w-auto"
          src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
          alt="Workflow"
        />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Lakoohacha Admin
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6">
            <TextInput
              name="email"
              type="email"
              label="Email"
              placeholder="Enter email"
              value={loginState.email}
              onChage={onInputChange}
            />
            <TextInput
              name="password"
              type="password"
              label="Password"
              placeholder="Enter password"
              value={loginState.password}
              onChage={onInputChange}
            />

            <div>
              <button
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                onClick={signIn}
              >
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
    </LoginLayout>
  );
};
